module.exports = __webpack_public_path__ + "static/media/TapThinRoot2.12f07de4.PNG";